<template>
    <Tabs :customer="customer" />

    <DCard>
        <DRow class="mx-1 my-3">
            <DCol>
                <DButton
                    id="website-butler"
                    :label="__('customers.communications.filters.all')"
                    mini
                    @click="filterRecords()"
                />
                <DButton
                    id="website-butler"
                    :label="__('customers.communications.filters.emails')"
                    mini
                    @click="filterRecords('email')"
                />
                <DButton
                    id="website-butler"
                    :label="__('customers.communications.filters.sms')"
                    mini
                    @click="filterRecords('sms')"
                />
            </DCol>
        </DRow>
        <DRow>
            <DCol>
                <DTable
                    :items="data.data"
                    :fields="fields"
                >
                    <template #subject="{item}">
                        <td>
                            {{ item.type === 'sms' ? __(`tools.sms.samples.${item.subject}.${item.subject}`) : item.subject }}
                        </td>
                    </template>
                    <template #recipients="{item}">
                        <td>
                            {{ parseRecipients(item) }}
                        </td>
                    </template>
                    <template #actions="{item}">
                        <td>
                            <div style="display: flex; grid-gap: 10px;">
                                <DButton
                                    icon="eye"
                                    mini
                                    @click="displayModal(item)"
                                />
                            </div>
                        </td>
                    </template>
                    <template #created_at="{item}">
                        <td>
                            {{ setDateFormat(item.created_at, 'YYYY-MM-DD hh:mm:ss A') }}
                        </td>
                    </template>
                </DTable>
            </DCol>
        </DRow>
        <DFabs>
            <s-s-o-fab
                :customer="customer"
                @open-modal="showCreateCloudpitCustomerModal = true"
                @close-modal="showCreateCloudpitCustomerModal = false"
            />
        </DFabs>

        <DPagination
            v-if="data.last_page > 1"
            class="pb-2"
            :active-page="data.current_page"
            :pages="data.last_page"
            align="center"
            @update:activePage="changePage"
        />
        <ShowEmailModal
            :show-modal="showEmailModal"
            :email-id="modalEmailId"
            :customer="customer"
            @closeModal="closeModal"
        />

        <ShowSmsModal
            :show-modal="showSmsModal"
            :sms-id="modalEmailId"
            :customer="customer"
            @closeModal="closeModal"
        />

        <CreateCloudPitCustomerModal
            :customer="customer"
            :show-modal="showCreateCloudpitCustomerModal"
            @close-modal="showCreateCloudpitCustomerModal = false"
        />
    </DCard>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'
import ShowEmailModal from '~@/Components/Customers/Emails/ShowEmailModal'
import SSOFab from '~@/Components/Customers/SSOFab'
import CreateCloudPitCustomerModal from '~@/Components/Customers/CreateCloudPitCustomerModal'
import ShowSmsModal from '~@/Components/Customers/Sms/ShowSmsModal'
import Tabs from '~@/Pages/Customers/EmailArchives/Tabs'

export default {
    name: 'CustomerEmailArchiveIndex',
    components: {
        Tabs,
        ShowSmsModal,
        CreateCloudPitCustomerModal,
        SSOFab,
        ShowEmailModal
    },
    layout: [App, CustomerBase],
    props: {
        data: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        type: {
            type: String,
            default: () => { return null }
        }
    },
    data () {
        return {
            fields: [
                { key: 'subject', label: this.__('customers.communications.subject') },
                { key: 'recipients', label: this.__('customers.communications.recipients') },
                { key: 'status', label: this.__('customers.communications.status') },
                { key: 'created_at', label: this.__('customers.communications.created') },
                { key: 'actions', label: '' }
            ],
            showEmailModal: false,
            showSmsModal: false,
            modalEmailId: 0,
            modalSmsId: 0,
            showCreateCloudpitCustomerModal: false
        }
    },
    methods: {
        changePage (page) {
            const queryParameters = { customer: this.customer.id, type: this.type }

            if (page !== 1) {
                queryParameters._query = { page: page }
            }

            this.$inertia.get(this.$route('customers.customers.communications.index', queryParameters))
        },
        parseRecipients (item) {
            const recipients = JSON.parse(JSON.parse(item.recipients))
            return Array.isArray(recipients) && recipients.length > 0
                ? recipients.join(', ')
                : ''
        },
        displayModal (item) {
            if (item.type === 'email') {
                this.showEmailModal = true
                this.showSmsModal = false
                this.modalEmailId = item.id
            }

            if (item.type === 'sms') {
                this.showSmsModal = true
                this.showEmailModal = false
                this.modalEmailId = item.id
            }
        },
        closeModal () {
            this.showEmailModal = false
            this.showSmsModal = false
        },
        filterRecords (type) {
            const queryParameters = { customer: this.customer.id, type: type }
            this.$inertia.get(this.$route('customers.customers.communications.index', queryParameters))
        }
    }
}
</script>
